import AdminClient from "../apis/adminClient";
const adminClient = new AdminClient();

const state = {
  faqList: [],
  faqPage: null,
  faqPageTotal: 0,
  faqTotalElemtnts: 0
};

const getters = {
  getFaqList(state) {
    return state.faqList;
  },

  getFaqPage(state) {
    if (state.faqPage === null) {
      return 0;
    } else {
      return state.faqPage.pageNumber + 1;
    }
  },
  getFaqPageTotal(state) {
    return state.faqPageTotal;
  },
  getFaqTotalElements(state) {
    return state.faqTotalElemtnts;
  }
};

const mutations = {
  FAQ_LIST(state, data) {
    state.faqList = data.resultFaqList;
    state.faqPage = data.page;
    state.faqPageTotal = data.pageTotal;
    state.faqTotalElemtnts = data.totalElemtnts;
  },
  FAQ_LIST_ADD(state, data) {
    state.faqList = [].concat.apply(state.faqList, data.resultFaqList);
    state.faqPage = data.page;
    state.faqPageTotal = data.pageTotal;
    state.faqTotalElemtnts = data.totalElemtnts;
  },
  FAQ_INIT(state) {
    state.faqList = [];
    state.faqPage = null;
    state.faqPageTotal = 0;
    state.faqTotalElemtnts = 0;
  }
};

const actions = {
  async REQUEST_FAQ_LIST({ commit }, parameter) {
    try {
      commit("START_LOADING");
      const data = await adminClient.getFaqList(parameter);

      if (data?.result !== "success") {
        return alert(data.message);
      }

      if (data.page.pageNumber !== 0) {
        return commit("FAQ_LIST_ADD", data);
      }

      return commit("FAQ_LIST", data);
    } catch (e) {
      if (e === "refresh") {
        return;
      }
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
